export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12816.d8119e0a.jpg";